import * as actions from '../../redux/actions';

import { KuposModal } from '../../../common';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const StartPopup = props => {
	return (
		<div className="themes-start-popup">
			<KuposModal
				showModal={props.showPopup}

				backdrop={props.backdrop}
				onHide={props.onHide}
				noPadding
				noBackground
			>
				<div className="bip-info-modal-container">
					<div className="close-button pointer" onClick={() => props.setShowpop(false)}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="25"
							height="25"
							fill="white"
							class="bi bi-x-lg"
							viewBox="0 0 16 16"
						>
							<path
								fill-rule="evenodd"
								d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
							/>
							<path
								fill-rule="evenodd"
								d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
							/>
						</svg>
					</div>
					<div>
						<img src={props.imageSource} />
					</div>
				</div>
			</KuposModal>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(StartPopup);



// WEBPACK FOOTER //
// ./src/features/themes/common/popup/StartPopup.js